import { Grid } from '@mui/material';
import { useCallback, useEffect, useMemo } from 'react';
import { useParams } from 'react-router';

import DocumentationMS from '../../api/documentation';
import SidebarNavigation from '../../components/SidebarNavigation/SidebarNavigation';
import useApiQuery from '../../hooks/useApiQuery';

import PageContent from './PageContent';

import type { NavMenuItem } from '@/types';

interface PageData {
  title: string;
  children?: PageData[];
}

const Documentation = () => {
  const { pageTitle = import.meta.env.VITE_CONFLUENCE_HOMEPAGE } = useParams();
  const currentPath = `/docs/${pageTitle}`;

  const { data: pages = [], makeApiCall: getChildrenPages } = useApiQuery<PageData[]>(
    DocumentationMS.getChildrenPages.bind(DocumentationMS) as unknown as (
      ...args: unknown[]
    ) => Promise<PageData[]>
  );

  useEffect(() => {
    getChildrenPages(import.meta.env.VITE_CONFLUENCE_HOMEPAGE_ID);
  }, [getChildrenPages]);

  const formatPagesForNavigation = useCallback((pagesData: PageData[]): NavMenuItem[] => {
    if (!pagesData.length) return [];

    return pagesData.map(page => ({
      title: page.title,
      path: `/docs/${page.title}`,
      children: page.children ? formatPagesForNavigation(page.children) : [],
    }));
  }, []);

  const navigationItems: NavMenuItem[] = useMemo(
    () => [
      {
        title: import.meta.env.VITE_CONFLUENCE_HOMEPAGE,
        path: `/docs/${import.meta.env.VITE_CONFLUENCE_HOMEPAGE}`,
        children: [],
      },
      ...formatPagesForNavigation(pages),
    ],
    [formatPagesForNavigation, pages]
  );

  return (
    <Grid
      container
      justifyContent='space-between'
    >
      <Grid
        item
        xs={3}
      >
        <SidebarNavigation
          menuItems={navigationItems}
          currentPath={currentPath}
        />
      </Grid>
      <Grid
        item
        xs={8}
      >
        <PageContent pageTitle={pageTitle} />
      </Grid>
    </Grid>
  );
};

export default Documentation;
